import { SVGProps } from "react";
export const TemplateIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="var(--start-color, #000)"
      // fillOpacity={0.65}
      d="M14.256 18.934H3.454c.05.694.447 1.066 1.207 1.066h8.389c.76 0 1.157-.372 1.206-1.066Zm1.62-2.29H1.835c.124.753.479 1.166 1.306 1.166h11.43c.826 0 1.181-.413 1.305-1.165ZM2.595 15.307h12.53c1.735 0 2.594-.851 2.594-2.562V9.496c-.22.026-.44.04-.66.041a6.09 6.09 0 0 1-.67-.041v3.182c0 .86-.463 1.297-1.281 1.297H2.612c-.81 0-1.28-.438-1.28-1.297V4.04c0-.859.47-1.305 1.28-1.305h9.347c.125-.47.32-.92.578-1.332H2.595C.868 1.404 0 2.264 0 3.967v8.777c0 1.702.867 2.562 2.595 2.562ZM17.058 0c-2.28 0-4.198 1.91-4.198 4.198a4.215 4.215 0 0 0 4.198 4.199c2.297 0 4.198-1.893 4.198-4.198 0-2.306-1.9-4.199-4.198-4.199Zm-.008 1.471c.29 0 .546.198.546.513v1.71h1.578c.28 0 .512.232.512.513a.513.513 0 0 1-.512.504h-1.579v1.71c0 .315-.256.505-.545.505-.281 0-.538-.19-.538-.505v-1.71h-1.578a.508.508 0 0 1 0-1.017h1.578v-1.71c0-.315.257-.513.538-.513Z"
    />
    <path
      fill="var(--start-color, #000)"
      // fillOpacity={0.65}
      d="M3.6 6.4a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Zm0-1.84a.64.64 0 1 1-.636.64.64.64 0 0 1 .636-.636V4.56ZM11.487 7.384l-3.423 3.423L5.53 8.272a.634.634 0 0 0-.894 0L1.2 12v1.6l3.904-3.953 2.086 2.054-2.378 2.377h1.744l5.356-5.356L16.4 13.6V12l-4.019-4.616a.634.634 0 0 0-.894 0Z"
    />
  </svg>
);
